import React from 'react';

interface StatusBadgeProps {
    status: string;
    displayText?: string; // Optional: text to display (if different from status)
    className?: string;
}

/**
 * Reusable status badge component for campaign requests
 * Provides consistent styling across list and detail views
 *
 * @param status - The status name that determines the badge color
 * @param displayText - Optional text to display in the badge (defaults to status)
 * @param className - Additional CSS classes
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({
    status,
    displayText,
    className = '',
}) => {
    const getStatusClasses = (statusName: string) => {
        switch (statusName) {
            case 'New':
                return 'bg-[#97D7E1] text-white';
            case 'Approved':
                return 'bg-primary text-white';
            case 'Rejected':
                return 'bg-[#F02D3A] text-white';
            case 'New: Call':
                return 'bg-primary text-black';
            case 'New: Wait':
                return 'bg-[#FEBF3E] text-black';
            case 'Called: 1x':
                return 'bg-[#AFC12D] text-black';
            case 'Contacted':
                return 'bg-[#FEBF3E] text-black';
            default:
                return 'bg-whiten text-black';
        }
    };

    const capitalizeFirstLetter = (str: string) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const textToDisplay = displayText || status;

    return (
        <div
            className={`inline-flex rounded-full px-3 py-1 text-sm hover:bg-opacity-90 ${getStatusClasses(
                status
            )} ${className}`}
        >
            {capitalizeFirstLetter(textToDisplay)}
        </div>
    );
};

export default StatusBadge;
